Eloca.behaviors.lojaFormBroker = function (context) {
    const $broker = $(context).find('.js-loja-broker');
    if (! $broker.length) {
        return;
    }

    const $camposSite = $(context).find('.js-loja-campos-site');
    const atualizar = function () {
        $camposSite.toggle(! $broker.is(':checked'));
    };

    $broker.on('change', atualizar);
    atualizar();
};
